import { GAService } from './ga.service';
import { GTMService } from './gtm.service';

export const Services = [
	GAService,
	GTMService,
];
